import { Provider as InversifyProvider } from 'inversify-react';
import { StrictMode } from 'react';
import * as ReactDOM from 'react-dom/client';
import 'reflect-metadata';

import { Configuration } from '@desygner/ui-core-configuration';
import { MonitoringService } from '@desygner/ui-core-monitoring';

import { App } from './app/app';
import { IErrorManager } from './core/viewer/error-manager';
import { IViewerLoader } from './core/viewer/viewer-loader';
import { appContainer } from './inversify.config';
import { TYPES } from './inversify.types';

class ApplicationLoader {
  private errorManager: IErrorManager = appContainer.get(TYPES.Viewer.ErrorManager);

  constructor() {
    this.initializeMonitoring();
    this.initializeAppLoader();
    this.renderApplication();
  }

  private initializeMonitoring() {
    try {
      const monitoringService = MonitoringService.getInstance();
      const config = process.env.CONFIG as unknown as Configuration;

      monitoringService.initialize({
        environment: config.environment,
        release: config.release,
        tracesSampleRate: process.env.SENTRY_TRACE_SAMPLE_RATE,
        replaysSessionSampleRate: process.env.SENTRY_REPLAYS_SESSION_SAMPLE_RATE,
        sampleRate: process.env.SENTRY_SAMPLE_RATE,
        replaysOnErrorSampleRate: process.env.SENTRY_REPLAYS_ON_ERROR_SAMPLE_RATE,
        ...config.sentry,
      });
    } catch (error) {
      console.error('Failed to initialize monitoring:', error);
    }
  }

  private initializeAppLoader() {
    try {
      const appLoader: IViewerLoader = appContainer.get(TYPES.Viewer.ViewerLoader);

      appLoader.initialize();
    } catch (error) {
      this.errorManager.handleUnknownError(error as Error);
    }
  }

  private renderApplication() {
    try {
      const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);

      root.render(
        <StrictMode>
          <InversifyProvider container={appContainer}>
            <App />
          </InversifyProvider>
        </StrictMode>
      );
    } catch (error) {
      this.errorManager.handleUnknownError(error as Error);
    }
  }
}

new ApplicationLoader();
